import { CheckCircle, MessageCircle, User } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";

export const FeedbackAnalyticsCard = ({ feedbackStats }) => {
  if (!feedbackStats || !feedbackStats.total) return null;
  return (
          <Card className="border-slate-200" data-testid="feedback-analytics-card">
            <CardHeader>
              <CardTitle className="text-lg flex items-center gap-2">
                <CheckCircle className="w-5 h-5 text-emerald-500" />
                Customer Feedback Analytics
              </CardTitle>
              <CardDescription>
                How customers respond after AI answers (last 7 days: {feedbackStats.last_7_days?.resolution_rate || 0}% resolved)
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {/* Answered */}
                <div className="p-4 rounded-lg bg-emerald-50 border border-emerald-100" data-testid="feedback-answered">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-emerald-600 font-medium">Question Answered</p>
                      <p className="text-2xl font-bold text-emerald-700">{feedbackStats.answered}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-lg font-semibold text-emerald-600">{feedbackStats.percentages?.answered || 0}%</p>
                      <CheckCircle className="w-6 h-6 text-emerald-500 ml-auto" />
                    </div>
                  </div>
                </div>
                
                {/* Need More Help */}
                <div className="p-4 rounded-lg bg-amber-50 border border-amber-100" data-testid="feedback-more-help">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-amber-600 font-medium">Need More Help</p>
                      <p className="text-2xl font-bold text-amber-700">{feedbackStats.need_more_help}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-lg font-semibold text-amber-600">{feedbackStats.percentages?.need_more_help || 0}%</p>
                      <MessageCircle className="w-6 h-6 text-amber-500 ml-auto" />
                    </div>
                  </div>
                </div>
                
                {/* Request Human */}
                <div className="p-4 rounded-lg bg-blue-50 border border-blue-100" data-testid="feedback-escalated">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-blue-600 font-medium">Escalated to Human</p>
                      <p className="text-2xl font-bold text-blue-700">{feedbackStats.request_human}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-lg font-semibold text-blue-600">{feedbackStats.percentages?.request_human || 0}%</p>
                      <User className="w-6 h-6 text-blue-500 ml-auto" />
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Summary stats */}
              <div className="mt-4 pt-4 border-t border-slate-200 flex items-center justify-between text-sm text-slate-500">
                <span>Total feedback responses: {feedbackStats.total}</span>
                <span>Last 7 days: {feedbackStats.last_7_days?.total || 0} responses</span>
              </div>
            </CardContent>
          </Card>
  );
};
